import { Box, Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select } from "@mui/material";

const MultiSelectDropDown2 = (props) => {
  const { width, height, domId = "Multi_Select", labelText, selectedData, dataSource, setSelectedData, sx } = props;

  const customRenderValue = (selected, datasourceLength) => {
    if (selected.length === datasourceLength) {
      return "All"; // Only show "All" if selected length matches datasource length
    }
    if (selected.length === 0) {
      return "Select";
    }
    if (selected.length > 1) {
      let w = width - 50;
      return (
        <div style={{ display: "flex", alignItems: "center", flexWrap: "nowrap", gap: "4px", width: "100%" }}>
          <span style={{ maxWidth: `${w}px`, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{selected[0]}</span> +{" "}
          {selected.length - 1} more
        </div>
      );
    }
    return selected.join(", ");
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    if (value.includes("All")) {
      setSelectedData(
        selectedData.length === dataSource.length
          ? [] // Deselect all if "All" was already selected
          : Array.from(dataSource) // Select all options
      );
    } else {
      setSelectedData(typeof value === "string" ? value.split(",") : value);
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <FormControl
        sx={{
          mr: "14px",
          width: `${width}px` || "250px",
          ...sx,
        }}
        id={`${domId}_Type_Dropdown`}
        fullWidth
        size="small"
      >
        <InputLabel
          id={`${domId}_Label`}
          sx={{
            backgroundColor: "white", // Ensure label is not transparent
            padding: "0 4px 0 0", // Add padding to avoid overlap
            fontSize: "16px",
            color: "rgba(0,0,0,0.5) !important",
            fontWeight: "500",
            "&.Mui-focused": {
              color: "#E3165B !important",
            },
          }}
        >
          {labelText}
        </InputLabel>
        <Select
          labelId={`${domId}_Label`}
          id={domId}
          name={domId}
          label={labelText}
          multiple
          value={selectedData}
          onChange={handleChange}
          renderValue={(selected) => customRenderValue(selected, dataSource.length)}
          sx={{
            height: `${height}px` || "36px",
            fontSize: "14px",
            paddingRight: "10px",
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E3165B",
            },
            "&.Mui-focused .MuiFormLabel-root": {
              color: "#E3165B !important",
            },
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 250,
                overflowY: "auto",
                maxWidth: width,
              },
              sx: {
                "&::-webkit-scrollbar": {
                  // display: "none",
                },
              },
            },
            autoFocus: false,
            MenuListProps: {
              autoFocusItem: false,
            },
          }}
          disabled={dataSource.length === 0}
        >
          {/* Add "All" option */}
          <MenuItem
            value="All"
            sx={{
              height: "30px", // Set consistent height
              padding: "0px", // Adjust padding to match others
              "&.Mui-selected": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Checkbox checked={selectedData.length === dataSource.length} />
            <ListItemText
              primary="Select All"
              primaryTypographyProps={{
                style: {
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  fontSize: "14px",
                  color: "#000000",
                  fontFamily: "CircularTT-Book",
                },
              }}
            />
          </MenuItem>
          {/* Divider for separation */}

          {Array.from(dataSource).length > 0 &&
            Array.from(dataSource)?.map((option) => (
              <MenuItem
                key={option}
                value={option}
                id={`${domId}_Type_Dropdown_Option_${option.replace(/\s+/g, "_")}`}
                sx={{
                  height: "34px", // Set consistent height
                  padding: "8px 8px 8px 0px", // Adjust padding to match others
                  "&.Mui-selected": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                <Checkbox checked={selectedData.indexOf(option) > -1} />
                <ListItemText
                  primary={option}
                  primaryTypographyProps={{
                    style: {
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      fontSize: "14px",
                      color: "#000000",
                      fontFamily: "CircularTT-Book",
                    },
                  }}
                />
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default MultiSelectDropDown2;
